import { createContext } from "react";

const LocationContext = createContext({
    lattitude:"26.85",
    longitude:"80.9167",
});

export default LocationContext;